<template>
    <div class="bubble speechBubble-right"
         :class="{ expanded: expanded, inactive: !expanded && anyExpanded }" @mouseover="hover()"
         @mouseleave="endHover()">
        <div v-if="submitted" class="submitted">
            <p>
                Ihre Antwort wurde gesendet! Wir werden uns sobald wie möglich bei Ihnen melden.
            </p>
        </div>
        <div v-else class="bubbleContent">
            <form v-show="expanded">
                <textarea class="contactArea" placeholder="..." v-model="text" @focus="focus()"
                          @blur="blur()"></textarea>
                <label for="email">E-Mail</label>
                <input id="email" type="email" v-model="email" @focus="focus()" @blur="blur()">
                <div v-if="error" v-html="errorMessage"></div>
                <div id="privacyAgreementBox">
                    <input type="checkbox" id="privacyAgreement" v-model="privacyAgreed">
                    <label for="privacyAgreement">Ich bin einverstanden, dass meine oben angegebenen Daten für die Bearbeitung der Anfrage gemäß den <router-link :to="{name: 'datenschutz'}">Datenschutzbedingungen</router-link> gespeichert und verwendet werden.</label>
                </div>
                <vue-recaptcha v-if="captchaActive" :sitekey="captchaKey" badge="bottomright"
                               loadRecaptchaScript
                               ref="recaptcha"
                               @verify="onCaptchaVerified" @focus="onVerify" @render="onVerify">
                    <button class="submitButton" :disabled="(! privacyAgreed) || submitted">Absenden</button>
                </vue-recaptcha>
            </form>
            <div v-show="! expanded" class="placeholder">
                <p>Schreibe hier deinen eigenen Einwand rein</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import VueRecaptcha from 'vue-recaptcha';
    import axios from "axios";
    import BasicComponent from "@/components/BasicComponent";

    @Component({
        components: {VueRecaptcha},
        props: {anyExpanded: Boolean}
    })
    export default class ContactBubble extends BasicComponent {

        data() {
            return {
                hovered: false,
                focused: false,
                verifying: false,
                text: "",
                email: "",
                submitted: false,
                error: false,
                errorMessage: "",
                captchaToken: null,
                privacyAgreed: false
            }
        }

        hover() {
            this.hovered = true;
        }

        endHover() {
            this.hovered = false;
        }

        focus() {
            this.focused = true;
        }

        blur() {
            this.focused = false;
        }

        get expanded() {
            return !this.submitted && (this.hovered || this.focused || this.verifying);
        }

        get captchaActive() {
            return this.expanded || this.verifying;
        }

        onCaptchaVerified(token) {
            this.captchaToken = token;
            this.$refs.recaptcha.reset();
            this.onSubmit();
        }

        onSubmit(event) {
            if (event) event.preventDefault();
            this.verifying = true;
            const token = this.captchaToken;
            //if (token == null) return;

            if (!this.validateInput()) {
                this.error = true;
                return;
            }

            this.sendMail(token);
        }

        onVerify() {
            this.verifying = true;
        }

        sendMail(token) {
            axios.post("https://wersglaubt.at/contact.php", {
                "token": token,
                "email": this.email,
                "text": this.text
            }).then((response) => {
                this.submitted = true;
            }).catch((err) => {
                this.error = true;
                this.errorMessage = "Ein unbekannter Fehler ist aufgetreten. Bitte senden Sie Ihre Anfrage per Mail an <!--<a href='mailto:kontakt@wersglaubt.at?subject=WERSGLAUBT.AT Anfrage&body=" + this.text + "'>-->kontakt[AT]wersglaubt.at</a>. Danke für Ihr Verständnis!";
                console.error(err);
            });
        }

        validateInput() {
            if (!this.validEmail()) {
                this.errorMessage = "Bitte geben Sie eine gültige Email Adresse ein.";
                return false;
            }

            return true;
        }

        validEmail() {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.email);
        }
    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Variables.scss";
    @import "@/stylesheets/SpeechBubble.scss";

    .bubble {
        @extend .homeSpeechBubble;

        &.inactive {
            opacity: 0.2;
        }

        .submitted {
            font-size: 20px;
            overflow-y: hidden;
        }

        .bubbleContent {

            height: calc(#{$homeSpeechBubble-height} - 2 * (#{$homeSpeechBubble-padding}));
            width: 100%;

            * {
                box-sizing: border-box;
            }

            form {
                height: 100%;
                display: inline-flex;
                flex-direction: column;

                .contactArea {
                    width: 100%;
                    flex: 1;

                    resize: none;
                    box-sizing: border-box;

                    border: none;

                    font-size: 20px;
                }

                .submitButton {
                    margin-top: 15px;

                    &[disabled="disabled"] {
                        $color: grey;

                        color: $color;

                        border-color: $color;
                        pointer-events: none;

                        &:hover {
                            background-color: white;
                            cursor: not-allowed;
                        }
                    }
                }
            }


            .placeholder {
                p {
                    hyphens: none;
                    font-size: 24px;
                    font-weight: 900;
                    font-style: italic;
                    text-transform: uppercase;

                    @media screen and (max-width: 280px) {
                        font-size: 8vw;
                    }
                }
            }
        }

        &.expanded {
            $height: 500px;
            height: auto;

            .bubbleContent {
                height: calc(#{$height} - 2 * (#{$homeSpeechBubble-padding}));
                transition: height 200ms ease-in !important;
                overflow: hidden !important;
            }
        }

        #privacyAgreementBox {
            max-width: 100%;

            label {
                font-variant: none;
                white-space: pre-wrap;
                text-align: left;
                display: inline-block;
                font-size: 16px;

                width: 100%;

                a {
                    display: inline;
                }
            }
        }

    }
</style>
<style lang="scss">
    .grecaptcha-badge {
        width: 0 !important;
    }
</style>
